import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { message } from 'antd';
import LoginPage from './pages/LoginPage';
import MainLayout from './components/MainLayout';
import H5App from './h5/H5App';
import H5LoginPage from './h5/pages/H5LoginPage';
import HomePage from './pages/HomePage';
import EssayWizard from './pages/EssayWizard';
import BatchCorrectionPage from './pages/BatchCorrectionPage';
import HistoryPage from './pages/HistoryPage';
import AnalysisPage from './pages/AnalysisPage';
import StatisticsPage from './pages/StatisticsPage';
import CorrectionResult from './pages/CorrectionResult';
import ClassManagement from './pages/ClassManagement';
import StudentManagement from './pages/StudentManagement';
import TopicManagement from './pages/TopicManagement';
import ProfilePage from './pages/ProfilePage';
import { getToken, removeToken } from './utils/auth';

// const { Content } = Layout;

function AppContent() {
  // 初始化时立即检查 localStorage 中的 token
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = getToken();
    return !!token;
  });
  const location = useLocation();
  const isH5Route = location.pathname === '/h5' || location.pathname.startsWith('/h5/');

  useEffect(() => {
    // 再次验证（以防万一）
    const token = getToken();
    setIsAuthenticated(!!token);
  }, []);

  const handleLogin = (token: string) => {
    setIsAuthenticated(true);
    message.success('登录成功！');
  };

  const handleLogout = () => {
    removeToken();
    setIsAuthenticated(false);
    message.success('已退出登录');
  };

  return (
    <div className="App">
      {!isAuthenticated ? (
        <Routes>
          {isH5Route ? (
            <>
              <Route path="/h5/login" element={<H5LoginPage onLogin={handleLogin} />} />
              <Route path="/h5/*" element={<Navigate to="/h5/login" replace />} />
            </>
          ) : (
            <>
            <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
            </>
          )}
        </Routes>
      ) : isH5Route ? (
        <H5App onLogout={handleLogout} />
      ) : (
        <MainLayout onLogout={handleLogout}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/essay/new" element={<EssayWizard />} />
              <Route path="/essay/:id/edit" element={<EssayWizard />} />
              <Route path="/essay-wizard/continue/:id" element={<EssayWizard />} />
              <Route path="/essay/:essayId/result" element={<CorrectionResult />} />
              <Route path="/batch-correction" element={<BatchCorrectionPage />} />
              <Route path="/batch-correction/:batchId" element={<BatchCorrectionPage />} />
              <Route path="/history" element={<HistoryPage />} />
              <Route path="/analysis" element={<AnalysisPage />} />
              <Route path="/statistics" element={<StatisticsPage />} />
              <Route path="/classes" element={<ClassManagement />} />
              <Route path="/students" element={<StudentManagement />} />
              <Route path="/topics" element={<TopicManagement />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </MainLayout>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
